"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLinkedField = void 0;

var _ramda = require("ramda");

var isLinkedField = function isLinkedField(field) {
  var settings = field.settings;
  var linkType = (0, _ramda.prop)('linkType', settings);
  var linkField = (0, _ramda.prop)('linkField', settings);
  return linkType && linkField;
};

exports.isLinkedField = isLinkedField;